/**
 * Zoom of a Measurements chart that survives the 30-second auto-update (tri-server #1590).
 *
 * ApexCharts forgets a zoom when it is handed new options and series. The list therefore keeps
 * the zoom itself, per metric, and writes it back into the options it passes down as
 * `xaxis.min/max`.
 */
export interface ZoomRange {
  min: number;
  max: number;
}

/** The range of a `zoomed` / `scrolled` chart event, or null if it carries none that is usable. */
export const zoomRangeFromEvent = (event: any): ZoomRange | null => {
  const min = Number(event?.xaxis?.min);
  const max = Number(event?.xaxis?.max);
  return Number.isFinite(min) && Number.isFinite(max) && min < max ? { min, max } : null;
};

/** The full x range the chart was built with (the selected period), if it has one. */
export const fullRangeOf = (options: any): ZoomRange | null =>
  zoomRangeFromEvent({ xaxis: options?.xaxis });

/**
 * Whether the range shows the whole period or more. Resetting the zoom (toolbar button) reports
 * exactly this, and so does zooming out past the edges; both mean "not zoomed any more".
 */
export const coversFullRange = (range: ZoomRange, full: ZoomRange | null): boolean =>
  !full || (range.min <= full.min && range.max >= full.max);

export const sameRange = (a: ZoomRange | undefined, b: ZoomRange | undefined): boolean =>
  a === b || (!!a && !!b && a.min === b.min && a.max === b.max);
